<template>
    <div class="select-container" :class="{open: isOpen, nobor: border==false}" v-on-clickaway="away">
        <div class="select-input">
            <span class="fa fa-angle-down"></span>
            <input type="text" class="form-control form-control-sm"
                ref="input"
                :placeholder="place"
                v-model="keyWord"
                @input="toList"
                @focus="onFocus"/>
        </div>
        <div class="select-dropdown vld-parent" ref="i100" style="min-height: 30px;">
            <table class="table-select">
                <tbody>
                    <tr>
                        <td colspan="2" @click="select(null)">{{$t('all')}}</td>
                    </tr>
                    <tr v-for="(ret,index) in list" :key="index" @click="select(ret)">
                        <td>{{ret.Num}}</td>
                        <td>{{ret.Name}}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>
<script>
    import { mixin as clickaway } from 'vue-clickaway';
    export default {
        mixins: [ clickaway ],
        props: {
            value: {
                type: String,
                default: ''
            },
            border: {
                type: Boolean,
                default: true
            },
            place: {
                type: String,
                default: ''
            },
            disabled: {
                type: Boolean,
                default: false
            }
        },
        data: function(){
            return {
                keyWord: this.value,
                isOpen: false,
                list: [],
                isShow: false
            }
        },
        methods: {
            onFocus(){
                this.isOpen = true;
                if(!this.isShow) this.toList();
            },
            away() {
                this.isOpen = false;
            },
            select(item){
                if(item == null) this.keyWord = '';
                else this.keyWord = item.Name;
                this.isOpen = false;
                this.$emit('select', item);
            },
            onClear(){
                this.keyWord = '';
                this.$refs.input.focus();
            },
            toList(){
                this.list = [];
                let loading = this.$loading.show({
                    container: this.$refs.i100,
                    height: 25,
                    loader: 'dots'
                });
                this.$api().post('item/0/list', { Text: this.keyWord, ProductTypeId: 0 }).then(res => {
                    if(this.$isValid(res)){
                        this.list = res.data.Json.Items;
                        this.isShow = true;
                    }
                }).finally(function(){ loading.hide(); });
            }
        },
        watch: {
            value(val){
                this.keyWord = val;
            },
            disabled(value){
                this.isDisabled = value;
            }
        }
    }
</script>
<style scoped>
    .select-container{
        position: relative;
    }
    .select-container .form-control{
        padding-right: 30px;
    }
    .select-container .fa-search {
        position: absolute;
        left: 10px;
        top: 8px;
        color: #737373;
    }
    .select-container .fa-angle-down{
        position: absolute;
        right: 10px;
        top: 8px;
        font-weight: 600;
    }
    .select-container .select-dropdown {
        position: absolute;
        max-height: 300px;
        border: 1px solid #e4e7ea;
        border-radius: 3px;
        display: none;
        width: 100%;
        background: #fff;
        overflow: auto;
    }
    .select-container.open .select-dropdown{
        display: block;
        margin-top: 2px;
        z-index: 10;
    }
    .select-container .table-select{
        width: 100%;
    }
    .select-container .table-select tbody tr td{
        padding: 3px 8px;
        border: none;
    }
    .select-container .table-select tbody tr:hover{
        background: #f2f2f2;
        cursor: pointer;
    }
    .select-container.nobor .form-control{
        border: none;
    }
</style>